import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {waLink,profile,WHATSAPP_NUMBER} from '../data/content';
const {FiMessageCircle,FiMail,FiMapPin,FiPhone,FiArrowUpRight}=FiIcons;
function formatPhone(num) {
  const s=num.replace(/\D/g,'');
  if (s.length===12 && s.startsWith('91')) return `+91 ${s.slice(2,7)} ${s.slice(7)}`;
  return `+${s}`;
}
function Contact() {
return (
 <section className="pad contact-section" id="contact">
 <div className="wrap">
 <motion.div className="contact-card" initial={{opacity: 0,y: 24}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.6}}>
 <span className="eyebrow">Get in touch</span>
 <h2 className="h-section">Have a project in mind?<br /><span className="accent">Let's build it together.</span></h2>
 <p>Drop me a message on WhatsApp and I'll get back to you within a few hours — usually faster. Whether it's a full app or a single API,I'm happy to talk it through.</p>
 <div className="contact-actions">
 <a className="btn btn-whatsapp" href={waLink} target="_blank" rel="noreferrer">
 <SafeIcon icon={FiMessageCircle} /> Contact Us on WhatsApp <SafeIcon icon={FiArrowUpRight} />
 </a>
 <a className="btn btn-ghost" href={`mailto:${profile.email}`}>Email me</a>
 </div>
 <div className="contact-channels">
 <a className="channel" href={waLink} target="_blank" rel="noreferrer">
 <div className="ico"><SafeIcon icon={FiMessageCircle} /></div>
 <div className="lbl">WhatsApp</div>
 <div className="val">{formatPhone(WHATSAPP_NUMBER)}</div>
 </a>
 <a className="channel" href={`mailto:${profile.email}`}>
 <div className="ico"><SafeIcon icon={FiMail} /></div>
 <div className="lbl">Email</div>
 <div className="val">{profile.email}</div>
 </a>
 <div className="channel">
 <div className="ico"><SafeIcon icon={FiMapPin} /></div>
 <div className="lbl">Location</div>
 <div className="val">{profile.location}</div>
 </div>
 </div>
 </motion.div>
 </div>
 </section>
 );
}
export default Contact;
